module.exports = __webpack_public_path__ + "img/icon-googleads.e9272e5f.svg";